// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.connectToDbModal_modal__QCPE- {
  max-width: 880px;
  max-height: 850px;
  height: max-content;
  overflow: hidden;
  position: relative;
  background-color: #ffffff;
  z-index: 2; }

.connectToDbModal_header__hOInc {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  left: 0;
  background: #ffffff;
  z-index: 2;
  padding: 20px; }
  .connectToDbModal_header_title__9i4Hd {
    font-weight: 600;
    font-size: 24px;
    line-height: 150%;
    color: var(--HightEmphasis); }

.connectToDbModal_form__193Y7 {
  padding: 20px;
  overflow-y: auto;
  overflow-x: hidden; }
  .connectToDbModal_form_wrapper__jWa90 {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, auto);
    gap: 10px;
    padding-bottom: 40px; }
  .connectToDbModal_form_error__PwF02 {
    color: var(--Red); }
  .connectToDbModal_form__193Y7 .connectToDbModal_buttons__0jcVB {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    gap: 10px; }
    .connectToDbModal_form__193Y7 .connectToDbModal_buttons__0jcVB .connectToDbModal_cancel__UXiIC {
      background-color: #ffffff;
      color: #fe6100; }
      .connectToDbModal_form__193Y7 .connectToDbModal_buttons__0jcVB .connectToDbModal_cancel__UXiIC:hover {
        background-color: #fe6100;
        color: #ffffff; }

.connectToDbModal_close__4vIz6 {
  color: var(--HightEmphasis);
  cursor: pointer;
  z-index: 1;
  transition: all 0.4s; }
  .connectToDbModal_close__4vIz6:hover {
    color: var(--MediumEmphasis); }

.connectToDbModal_inputContainer__gITg4 {
  grid-column: span 2; }

.connectToDbModal_inputFull__qWjr8 {
  grid-column: 1 / span 2; }

.connectToDbModal_container__AdBDD {
  padding: 0 20px 0 20px; }

.connectToDbModal_buttonsNew__z4hyj {
  display: flex;
  justify-content: flex-end;
  margin-top: 50px;
  padding: 20px;
  gap: 10px; }

.connectToDbModal_label__JqJQ7 {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  /* 150% */
  margin-bottom: 5px; }
`, "",{"version":3,"sources":["webpack://./src/pages/configuration/components/ConnectToDbModal/connectToDbModal.module.scss","webpack://./src/styles/fonts.scss"],"names":[],"mappings":"AAGA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,UAAU,EAAA;;AAGZ;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,OAAO;EACP,mBAAmB;EACnB,UAAU;EACV,aAAa,EAAA;EACb;IChBA,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IDgBf,2BAA2B,EAAA;;AAI/B;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB,EAAA;EAClB;IACE,aAAa;IACb,qCAAqC;IACrC,mCAAmC;IACnC,SAAS;IACT,oBAAoB,EAAA;EAEtB;IACE,iBAAiB,EAAA;EAZrB;IAeI,aAAa;IACb,qBAAqB;IACrB,yBAAyB;IACzB,SAAS,EAAA;IAlBb;MAoBM,yBAAyB;MACzB,cAAc,EAAA;MArBpB;QAuBQ,yBAAyB;QACzB,cAAc,EAAA;;AAKtB;EACE,2BAA2B;EAC3B,eAAe;EACf,UAAU;EACV,oBAAoB,EAAA;EAJtB;IAMI,4BAA4B,EAAA;;AAGhC;EACE,mBAAmB,EAAA;;AAErB;EACE,uBAAuB,EAAA;;AAGzB;EACE,sBAAsB,EAAA;;AAExB;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,SAAS,EAAA;;AAEX;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EAAE,SAAA;EACnB,kBAAkB,EAAA","sourcesContent":["@import 'src/styles/media.scss';\n@import 'src/styles/fonts.scss';\n\n.modal {\n  max-width: 880px;\n  max-height: 850px;\n  height: max-content;\n  overflow: hidden;\n  position: relative;\n  background-color: #ffffff;\n  z-index: 2;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: sticky;\n  top: 0;\n  left: 0;\n  background: #ffffff;\n  z-index: 2;\n  padding: 20px;\n  &_title {\n    @include h2;\n    color: var(--HightEmphasis);\n  }\n}\n\n.form {\n  padding: 20px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  &_wrapper {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    grid-template-rows: repeat(3, auto);\n    gap: 10px;\n    padding-bottom: 40px;\n  }\n  &_error {\n    color: var(--Red);\n  }\n  .buttons {\n    display: flex;\n    align-items: flex-end;\n    justify-content: flex-end;\n    gap: 10px;\n    .cancel {\n      background-color: #ffffff;\n      color: #fe6100;\n      &:hover {\n        background-color: #fe6100;\n        color: #ffffff;\n      }\n    }\n  }\n}\n.close {\n  color: var(--HightEmphasis);\n  cursor: pointer;\n  z-index: 1;\n  transition: all 0.4s;\n  &:hover {\n    color: var(--MediumEmphasis);\n  }\n}\n.inputContainer {\n  grid-column: span 2;\n}\n.inputFull {\n  grid-column: 1 / span 2;\n}\n\n.container {\n  padding: 0 20px 0 20px;\n}\n.buttonsNew {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 50px;\n  padding: 20px;\n  gap: 10px;\n}\n.label {\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px; /* 150% */\n  margin-bottom: 5px;\n}\n","@mixin h1 {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 150%;\n}\n\n@mixin h2 {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n}\n\n@mixin h3 {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n}\n\n@mixin h4 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin h5 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin h6 {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin body1 {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin body2 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n@mixin body3 {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n}\n\n@mixin link1 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin link2 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin caption {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n}\n\n@mixin title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin button {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `connectToDbModal_modal__QCPE-`,
	"header": `connectToDbModal_header__hOInc`,
	"header_title": `connectToDbModal_header_title__9i4Hd`,
	"form": `connectToDbModal_form__193Y7`,
	"form_wrapper": `connectToDbModal_form_wrapper__jWa90`,
	"form_error": `connectToDbModal_form_error__PwF02`,
	"buttons": `connectToDbModal_buttons__0jcVB`,
	"cancel": `connectToDbModal_cancel__UXiIC`,
	"close": `connectToDbModal_close__4vIz6`,
	"inputContainer": `connectToDbModal_inputContainer__gITg4`,
	"inputFull": `connectToDbModal_inputFull__qWjr8`,
	"container": `connectToDbModal_container__AdBDD`,
	"buttonsNew": `connectToDbModal_buttonsNew__z4hyj`,
	"label": `connectToDbModal_label__JqJQ7`
};
export default ___CSS_LOADER_EXPORT___;
